import { store } from '@src/store';
import { estimatesApi } from '@src/service-definitions/estimates';

// Force the CE UI to refetch estimate data after the assistant applied a change.
// Every estimate query provides the 'Estimates' tag, so invalidating it refetches
// all mounted estimate queries (including the estimate-level view backing the UI).
export function refreshEstimateData(): void {
  store.dispatch(estimatesApi.util.invalidateTags(['Estimates']));
}
